import { HttpClient } from "@parkschannel/next-utils";
export class UtilityPagesApi {
    getUtilityPage(slug) {
        return this.client.get("/api/utils-pages/slugs/".concat(slug), {}, false);
    }
    constructor(client = new HttpClient()){
        this.client = client;
    }
}
